import React from "react";

const Contactus = () => {
  return (
    <div className="bg-[#fbaf14] text-white px-4 sm:px-6 md:px-10 py-16 flex flex-col md:flex-row items-center justify-between max-w-screen-2xl mx-auto gap-10">
      
      {/* Left Section */}
      <div className="w-full md:w-1/2 text-center md:text-left">
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold">
          <span className="text-white opacity-40">CONTACT US</span>
        </h2>
        <p className="text-lg sm:text-2xl md:text-3xl font-semibold mt-4 px-2 sm:px-4">
          Reach out to us and experience the <br />
          <span className="text-[#114497] font-extrabold">SAI STEELS</span> difference.
        </p>
      </div>

      {/* Right Section - Form */}
      <div className="w-full md:w-1/2 bg-transparent text-white">
        <form className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <input
            type="text"
            placeholder="Name"
            className="border-b-2 border-[#114497] text-white p-2 outline-none bg-transparent"
          />
          <input
            type="text"
            placeholder="Company"
            className="border-b-2 border-[#114497] text-white p-2 outline-none bg-transparent"
          />
          <input
            type="email"
            placeholder="Email"
            className="border-b-2 border-[#114497] text-white p-2 outline-none bg-transparent"
          />
          <input
            type="tel"
            placeholder="Phone"
            className="border-b-2 border-[#114497] text-white p-2 outline-none bg-transparent"
          />
          <input
            type="text"
            placeholder="Location"
            className="border-b-2 border-[#114497] text-white p-2 outline-none bg-transparent"
          />
          <select className="border-b-2 border-[#114497] text-black p-2 outline-none bg-transparent">
            <option>Select Enquiry</option>
            <option>Retail</option>
            <option>Project</option>
          </select>

          <div className="col-span-1 sm:col-span-2">
            <button
              type="submit"
              className="mt-4 px-6 py-3 bg-[#114497] text-white font-semibold w-full hover:bg-[#0d387c] transition"
            >
              Send Message →
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Contactus;
